<template>
  <div class="question7">
    <div class="header">
      <img src="../assets/head.jpeg">
    </div>

    <div class="body">
      <div>
        <p class="title">这是虚拟病例并非真实患者</p>
        <p class="content">
          李某，女，79岁，于16:30家人发现其发现意识不清，呼之能应，无大小便失禁，无发热、无口角歪斜，遂于我院急诊就诊，约18:00测血糖3.3mmol/L，予50%葡萄糖注射液40ml静推，20分钟后神志转清，复测血糖5.4mmol/L，为进一步诊治，收治我科。入院当天患者早餐进食少，午餐未进食，格列美脲未停药。1年前因滑倒以“腰椎压缩性骨折”收入我院骨科行保守治疗。20年前发现血糖升高，起始口服二甲双胍治疗，8年前加用格列美脲(4mg qd)治疗。既往无低血糖发作史。高血压病史20年，平素服用
          氯沙坦治疗。8年前脑梗发作，未留有明显后遗症，无特殊用药。COPD 14年，平素不规律使用异丙托溴铵气雾剂。
        </p>
        <p class="content">T:36.8 °C，P: 76 次/分 ，R: 18 次/分 ，BP:140/90 mmHg</p>
        <p
          class="content"
        >查体:神志清，精神萎靡，营养中等，发育良好，体型偏瘦，平车推入病房，无明显脱水貌，全身皮肤粘膜无黄染，无淤斑，未扪及浅表淋巴结肿大。胸廓前后径增大，双肺呼吸音减弱，呼气延长，可闻及散在湿性啰音，心率 76 次/分，律齐，无病理性杂音。</p>
        <p
          class="content"
        >实验室检查:Hb 89g/L，WBC 8.07×10<sup>9</sup>/L，N 0.76，L 0.35，PLT 269×10<sup>9</sup>/L;血糖3.3mmol/L， 尿蛋白及酮体阴性，ALT 14u/L，AST 17.8 u/L , BUN 11.2 mmol/L , Cr 126umol/L，UA 466 umol/L，尿微量白蛋白40.3mmol /L。头颅CT示右侧基底节区陈旧性腔梗。胸片显示双肺纹理增多、紊乱，双肺呈桶状，心影狭长。心电图显示T波改变。</p>
      </div>

      <div class="q">
        <van-row class="q_title">1. 在该老年糖尿病患者(≥60岁)个体化管理中，关于并发症控制&综合生活质量改善，您会考虑以下哪些因素?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q1">
          <van-checkbox name="A" shape="square">A. 患者的一般情况</van-checkbox>
          <van-checkbox name="B" shape="square">B. 跌倒风险的评估和预防</van-checkbox>
          <van-checkbox name="C" shape="square">C. 骨折风险的评估和预防</van-checkbox>
          <van-checkbox name="D" shape="square">D. 病人认知功能的评估和干预</van-checkbox>
          <van-checkbox name="E" shape="square">E. 心血管意外事件风险的预防和治疗</van-checkbox>
          <van-checkbox name="F" shape="square">F. 脑血管意外事件风险的预防和治疗</van-checkbox>
          <van-checkbox name="G" shape="square">G. 减少药物胃肠道不良反应</van-checkbox>
          <van-checkbox name="H" shape="square">H. 减少服药次数</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">2. 请问您目前可能会用于评估该患者健康状态<sup>[1]</sup>的指标有哪些?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q2">
          <van-checkbox name="A" shape="square">A. 高血压的严重程度</van-checkbox>
          <van-checkbox name="B" shape="square">B. 骨折的愈合程度</van-checkbox>
          <van-checkbox name="C" shape="square">C. 是否存在认知功能障碍及其严重程度</van-checkbox>
          <van-checkbox name="D" shape="square">
            <van-field v-model="q2_D" label-align="left" class="other" v-on:click.stop=stopCheck() label="D. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
        <van-row
          class="margin-right-12 margin-bottom-12"
        >(患者特征/健康状态分为健康状态、复杂/中等程度健康状态、非常复杂/健康状态较差三个级别，(健康: 较少慢性合并症、认知及日常生活能力好;复杂/中等程度健康状态:多种慢性合并症或 2 种以上工具性日 常生活能力损伤或轻至中度认知损害;非常复杂/健康状态较差:生活不能自理或合并终末期慢性疾病或中 至重度认知功能损害或 2 种以上日常生活能力丧失。)</van-row>
      </div>

      <div class="q">
        <van-row class="q_title">3. 请问您会根据以下哪些因素来评估老年糖尿病患者(≥60岁)的低血糖风险?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q3">
          <van-checkbox name="A" shape="square">A. 低血糖史</van-checkbox>
          <van-checkbox name="B" shape="square">B.低血糖防治知识了解情况(低血糖反应、预防、处理)</van-checkbox>
          <van-checkbox name="C" shape="square">C. 患者日常生活能力</van-checkbox>
          <van-checkbox name="D" shape="square">D. 患者的能量消耗和摄取是否稳定</van-checkbox>
          <van-checkbox name="E" shape="square">E. 降糖药物的降糖强度评估(胰岛素、磺脲类药物和联用降糖方案的使用情况)</van-checkbox>
          <van-checkbox name="F" shape="square">F. 过往血糖波动较大</van-checkbox>
          <van-checkbox name="G" shape="square">
            <van-field v-model="q3_G" label-align="left" v-on:click.stop=stopCheck() class="other" label="G. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title margin-bottom-12">4. 请问您会重点关注该患者的哪些方面?</van-row>
        <div class="clear"></div>
        <div class="margin-bottom-12 margin-right-12">
          <table>
            <tr>
              <th>因素分类</th>
              <th>老年糖尿病患者(≥60岁)个体化管理的考虑因素</th>
            </tr>
            <tr>
              <td>降糖方案制定</td>
              <td>
                <van-checkbox-group v-model="q4_1">
                  <van-checkbox name="A" shape="square">A. 参考患者特征/健康状态等级<sup>[1]</sup>制定降糖目标设定</van-checkbox>
                  <van-checkbox name="B" shape="square">B. 低血糖风险评估</van-checkbox>
                  <van-checkbox name="C" shape="square">C. 患者依从性</van-checkbox>
                  <van-checkbox name="D" shape="square">D. 减少过度降糖治疗</van-checkbox>
                </van-checkbox-group>
              </td>
            </tr>
            <tr>
              <td>并发症控制&综合生活 质量改善</td>
              <td>
                <van-checkbox-group v-model="q4_2">
                  <van-checkbox name="A" shape="square">A. 患者的一般情况</van-checkbox>
                  <van-checkbox name="B" shape="square">B. 心血管意外事件风险的预防和治疗</van-checkbox>
                  <van-checkbox name="C" shape="square">C. 避免药物胃肠道的影响</van-checkbox>
                  <van-checkbox name="D" shape="square">D. 减少服药次数</van-checkbox>
                  <van-checkbox name="E" shape="square">E. 减少多重用药</van-checkbox>
                </van-checkbox-group>
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
              >患者特征/健康状态分为健康状态、复杂/中等程度健康状态、非常复杂/健康状态较差三个级别，(健康:较少慢性合并症、 认知及日常生活能力好;复杂/中等程度健康状态:多种慢性合并症或 2 种以上工具性日常生活能力损伤或轻至中度认知损 害;非常复杂/健康状态较差:生活不能自理或合并终末期慢性疾病或中至重度认知功能损害或 2 种以上日常生活能力丧 失。)</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="q">
        <van-row class="q_title">5. 该患者的健康状态<sup>[1]</sup>等级是:</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q5">
          <van-radio name="A">A. 健康状态</van-radio>
          <van-radio name="B">B. 复杂/中等程度的健康状态</van-radio>
          <van-radio name="C">C. 非常复杂/健康状况较差</van-radio>
          <van-radio name="D">D. 我一般不做这方面的评估</van-radio>
        </van-radio-group>
        <van-row
          class="margin-right-12 margin-bottom-12"
        >(健康:较少慢性合并症、认知及日常生活能力好;复杂/中等程度健康状态:多种慢性合并症或 2 种以上 工具性日常生活能力损伤或轻至中度认知损害;非常复杂/健康状态较差:生活不能自理或合并终末期慢性 疾病或中至重度认知功能损害或 2 种以上日常生活能力丧失。)</van-row>
      </div>

      <div class="q">
        <van-row class="q_title">6. 该患者的健康状态分级可预测以下哪些问题?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q6">
          <van-checkbox name="A" shape="square">A. 患者的低血糖发生风险</van-checkbox>
          <van-checkbox name="B" shape="square">B. 药物负担/身体对于药物的耐受性</van-checkbox>
          <van-checkbox name="C" shape="square">C. 预期寿命</van-checkbox>
          <van-checkbox name="D" shape="square">
            <van-field v-model="q6_D" label-align="left" v-on:click.stop=stopCheck() class="other" label="D. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">7. 该患者的低血糖风险</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q7">
          <van-radio name="A">A. 高</van-radio>
          <van-radio name="B">B. 低</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">8. 该患者的心血管病总体风险<sup>[2]</sup></van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q8">
          <van-radio name="A">A. 低危</van-radio>
          <van-radio name="B">B. 高危</van-radio>
          <van-radio name="C">C. 极高危</van-radio>
        </van-radio-group>
        <van-row
          class="margin-right-12 margin-bottom-12"
        >(已被确诊为动脉粥样硬化性心血管病者(包括有症状的周围动脉疾病)直接列为极高危人群;符合如下条件 之一者直接列为高危人群:(1)糖尿病(年龄≥40 岁)。(2)单个危险因素水平极高者，包括:<sub class="sub">1</sub>LDL-C≥4.9 mmol/L(190 mg/dl)或 TC≥7.2mmol/L (280 mg/dl);<sub class="sub">2</sub>3 级高血压;<sub class="sub">3</sub>重度吸烟(≥30 支/d) )</van-row>
      </div>

      <div class="q">
        <van-row class="q_title">9. 该患者的胃肠道功能</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q9">
          <van-radio name="A">A. 良好</van-radio>
          <van-radio name="B">B. 一般</van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">10. 该患者经过治疗病情稳定后，HbA1c为8.3%，请问您如何看待该患者血糖控制情况?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q10">
          <van-radio name="A">A. 过于严格，需要更为宽松</van-radio>
          <van-radio name="B">B. 较为严格，需要根据患者的其他情况综合考量</van-radio>
          <van-radio name="C">C. 较为宽松，需要根据患者的其他情况综合考量</van-radio>
          <van-radio name="D">D. 过于宽松，需要更为严格</van-radio>
          <van-radio name="E">E. 适合该患者</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">11. 请问您认为该患者使用的降糖药物符合以下哪项描述?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q11">
          <van-radio name="A">A. 强度过大</van-radio>
          <van-radio name="B">B. 强度正好</van-radio>
          <van-radio name="C">C. 强度不足</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">12. 请问该患者的治疗方案是否还存在其他问题?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q12" @change="changeQ12()">
          <van-checkbox name="A" shape="square">A. 非常合理(选择这一项，则为单选)</van-checkbox>
          <van-checkbox name="B" shape="square" :disabled="q12_b_disable">B. 存在药物相互作用的问题</van-checkbox>
          <van-checkbox name="C" shape="square" :disabled="q12_c_disable">C. 降糖方案的疗效强度不足</van-checkbox>
          <van-checkbox name="D" shape="square" :disabled="q12_d_disable">D. 存在老年人慎用药物</van-checkbox>
          <van-checkbox name="E" shape="square" :disabled="q12_e_disable">E. 降压药物的强度不够</van-checkbox>
          <van-checkbox name="F" shape="square" :disabled="q12_f_disable">
            <van-field v-model="q12_F" label-align="left" v-on:click.stop=stopCheck() class="other" label="F. 其他，请注明" :disabled="q12_f_disable"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">13. 请问您认为该患者其他方面的检查是否充分?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q13">
          <van-radio name="A">A. 是</van-radio>
          <van-radio name="B">B. 否</van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">14. 请问您会通过以下哪些症状或检查来评估该患者的心血管疾病风险?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q14">
          <van-checkbox name="A" shape="square">A. 冠心病/心绞痛/心梗家族史</van-checkbox>
          <van-checkbox name="B" shape="square">B. 卒中家族史</van-checkbox>
          <van-checkbox name="C" shape="square">C. 吸烟</van-checkbox>
          <van-checkbox name="D" shape="square">D. 饮酒</van-checkbox>
          <van-checkbox name="E" shape="square">E. 高血压</van-checkbox>
          <van-checkbox name="F" shape="square">F. 血脂异常</van-checkbox>
          <van-checkbox name="G" shape="square">G. 腹型肥胖</van-checkbox>
          <van-checkbox name="H" shape="square">H. 肾功能不全</van-checkbox>
          <van-checkbox name="I" shape="square">
            <van-field v-model="q14_I" label-align="left" v-on:click.stop=stopCheck() class="other" label="I. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="q">
        <van-row class="q_title">15. 请问您认为该患者生活方式改善目标应有哪些?(可多选)</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q15">
          <van-checkbox name="A" shape="square">A. 更换降糖药物，降低低血糖风险</van-checkbox>
          <van-checkbox name="B" shape="square">B. 营养均衡</van-checkbox>
          <van-checkbox name="C" shape="square">C. 避免药物对肝肾功能的影响</van-checkbox>
          <van-checkbox name="D" shape="square">D. 增加运动</van-checkbox>
          <van-checkbox name="E" shape="square">E. 作息规律</van-checkbox>
          <van-checkbox name="F" shape="square">
            <van-field v-model="q15_F" label-align="left" v-on:click.stop=stopCheck() class="other" label="F. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">16. 根据您的评估，该患者具有哪些特点?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q16">
          <van-checkbox name="A" shape="square">A. 从健康状态分级来看基本属于高风险状态</van-checkbox>
          <van-checkbox name="B" shape="square">B. 低血糖风险高</van-checkbox>
          <van-checkbox name="C" shape="square">C. 心血管疾病风险高</van-checkbox>
          <van-checkbox name="D" shape="square">D. 血糖控制未达标</van-checkbox>
          <van-checkbox name="E" shape="square">
            <van-field v-model="q16_E" label-align="left" v-on:click.stop=stopCheck() class="other" label="E. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">17. 请问当您为老年糖尿病患者(≥60岁)选择降糖药物类别时，重要的因素有以下哪些?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q17">
          <van-checkbox name="A" shape="square">A. 有效降低 FPG/PPG</van-checkbox>
          <van-checkbox name="B" shape="square">B. 平稳降糖</van-checkbox>
          <van-checkbox name="C" shape="square">C. 药物间相互作用少</van-checkbox>
          <van-checkbox name="D" shape="square">D. 不增加心脑血管疾病风险</van-checkbox>
          <van-checkbox name="E" shape="square">
            <van-field v-model="q17_E" label-align="left" v-on:click.stop=stopCheck() class="other" label="E. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>
       <div style="margin: 24px;">
        <p>参考文献：</p>
        <p> [1] Older Adults: Standards of Medical Care in Diabetesd 2018[J]. Diabetes Care. 2018, 41(Suppl. 1): S119 –S125. </p>
        <p>[2] 中国心血管病预防指南 (2017) 写作组 , 中华心血管病杂志编辑委员会 . 中国心血管病预防指南 (2017)[J]. 中华心血管病杂志 , 2018, 46(1): 10 -25.</p>
      </div>

      <div class="apply">
        <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'

export default {
  name: "Question7",
  data() {
    return {
      q1: [],
      q2: [],
      q3: [],
      q4_1: [],
      q4_2: [],
      q5: [],
      q6: [],
      q7: [],
      q8: [],
      q9: [],
      q10: [],
      q11: [],
      q12: [],
      q13: [],
      q14: [],
      q15: [],
      q16: [],
      q17: [],

      q2_D: "",
      q3_G: "",
      q6_D: "",
      q12_F: "",
      q14_I: "",
      q15_F: "",
      q16_E: "",
      q17_E: "",
      periods: 1,
      q12_b_disable: false,
      q12_c_disable: false,
      q12_d_disable: false,
      q12_e_disable: false,
      q12_f_disable: false,
       isSubmit: false,
    };
  },

  methods: {
    changeQ12() {
       if(this.q12.includes("A")){
         this.q12_b_disable = true
         this.q12_c_disable = true
         this.q12_d_disable = true
         this.q12_e_disable = true
         this.q12_f_disable = true
       } else {
         this.q12_b_disable = false
         this.q12_c_disable = false
         this.q12_d_disable = false
         this.q12_e_disable = false
         this.q12_f_disable = false
       }
       return
    },
    // 阻止点击输入引起checkbox 选中变好
    stopCheck(){
      return false;
    },
    // 判断是否答题
    isAnswer(q, answer) {
      if (answer.length == 0) {
        this.$dialog.alert({
          message: "第" + q + "题没有选择"
        });
        return false;
      }
      return true;
    },
       // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
      // 弹框 确定后返回列表
    customAlert2(msg){
      this.$dialog.alert({
          message: msg
      }).then(
        ()=> {
          this.$router.go(-1);//返回上一层
        }
      )
      return
    },
    // 提交数据
    submit() {
        if(this.isSubmit){
        this.customAlert('正在提交')
        return false
      }
      this.isSubmit = true
      if(this.q12.includes('A')){
        this.q12 = ['A']
        this.q12_F = ''
      }
      // 去除空格
     // this.q1_H = this.q1_H.trim();
      this.q2_D = this.q2_D.trim();
      this.q3_G = this.q3_G.trim();
      this.q6_D = this.q6_D.trim();
      this.q12_F = this.q12_F.trim();
      this.q14_I = this.q14_I.trim();
      this.q15_F = this.q15_F.trim();
      this.q16_E = this.q16_E.trim();
      this.q17_E = this.q17_E.trim();

      // 判断是否楼选
      const a1 = this.isAnswer(1, this.q1);
      const a2 = this.isAnswer(2, this.q2);
      const a3 = this.isAnswer(3, this.q3);
      const a4_1 = this.isAnswer(4, this.q4_1);
      const a4_2 = this.isAnswer(4, this.q4_2);
      const a5 = this.isAnswer(5, this.q5);
      const a6 = this.isAnswer(6, this.q6);
      const a7 = this.isAnswer(7, this.q7);
      const a8 = this.isAnswer(8, this.q8);
      const a9 = this.isAnswer(9, this.q9);
      const a10 = this.isAnswer(10, this.q10);
      const a11 = this.isAnswer(11, this.q11);
      const a12 = this.isAnswer(12, this.q12);
      const a13 = this.isAnswer(13, this.q13);
      const a14 = this.isAnswer(14, this.q14);
      const a15 = this.isAnswer(15, this.q15);
      const a16 = this.isAnswer(16, this.q16);
      const a17 = this.isAnswer(17, this.q17);

      // // 判断是否选了其他，但是还没填其他
      // if (a1 && this.q1.includes("H") && this.q1_H.length == 0) {
      //   this.$dialog.alert({
      //     message: "请把第1题的其他的内容也填写一下"
      //   });
      //   return;
      // }
      // 判断是否选了其他，但是还没填其他
      if (a2 && this.q2.includes("D") && this.q2_D.length == 0) {
        this.$dialog.alert({
          message: "请把第2题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a3 && this.q3.includes("G") && this.q3_G.length == 0) {
        this.$dialog.alert({
          message: "请把第3题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a6 && this.q6.includes("D") && this.q6_D.length == 0) {
        this.$dialog.alert({
          message: "请把第6题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a12 && this.q12.includes("F") && this.q12_F.length == 0) {
        this.$dialog.alert({
          message: "请把第12题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a14 && this.q14.includes("I") && this.q14_I.length == 0) {
        this.$dialog.alert({
          message: "请把第14题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a15 && this.q15.includes("F") && this.q15_F.length == 0) {
        this.$dialog.alert({
          message: "请把第15题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a16 && this.q16.includes("E") && this.q16_E.length == 0) {
        this.$dialog.alert({
          message: "请把第16题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a17 && this.q17.includes("E") && this.q17_E.length == 0) {
        this.$dialog.alert({
          message: "请把第17题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      if (
        !(
          a1 &&
          a2 &&
          a3 &&
          a4_1 &&
          a4_2 &&
          a5 &&
          a6 &&
          a7 &&
          a8 &&
          a9 &&
          a10 &&
          a11 &&
          a12 &&
          a13 &&
          a14 &&
          a15 &&
          a16 &&
          a17
        )
      ) {
         this.isSubmit = false
        return;
      }

      // 提交数据
      let data = {};
      data.uid = Cookies.get('uid');
      data.question = 7;
      data.periods = this.periods;
      let answer = {};
      answer.q1 = this.q1;
      answer.q2 = this.q2;
      answer.q3 = this.q3;
      answer.q4_1 = this.q4_1;
      answer.q4_2 = this.q4_2;
      answer.q5 = this.q5;
      answer.q6 = this.q6;
      answer.q7 = this.q7;
      answer.q8 = this.q8;
      answer.q9 = this.q9;
      answer.q10 = this.q10;
      answer.q11 = this.q11;
      answer.q12 = this.q12;
      answer.q13 = this.q13;
      answer.q14 = this.q14;
      answer.q15 = this.q15;
      answer.q16 = this.q16;
      answer.q17 = this.q17;
      answer.q2_D = this.q2_D;
      answer.q3_G = this.q3_G;
      answer.q6_D = this.q6_D;
      answer.q12_F = this.q12_F;
      answer.q14_I = this.q14_I;
      answer.q15_F = this.q15_F;
      answer.q16_E = this.q16_E;
      answer.q17_E = this.q17_E;

      data.answer = answer;
      Http.post(api.answer, data).then(response => {
         this.isSubmit = false
        if (response.code == 1) {
          // 提交成功
          this.customAlert2("提交成功");
          return false;
        } else {
          // 发送失败
          this.customAlert(response.msg);
          return false;
        }
      });
      return false;
    }
  },
   mounted: function() {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.periods = this.$route.query.periods
  },
};
</script>

<style lang="less">
.question7 {
  font-size: 16px;
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .sub {
    display:inline-block;
    height:14px;
    width:14px;
    border-radius:50%;
    padding:1px;
    background:#0e0d0d;
    text-align:center;
    color: #fff
  }
  .van-cell {
    font-size: 16px;
  }
  .van-col {
    margin-bottom: 20px;
  }
   .van-field--disabled  {
    color: #c8c9cc;
  }
  .van-field__body {
    border-bottom: 2px solid #f7f7f7;
  }
  .van-field__label {
    width: 120px;
  }
  .clear {
    clear: both;
  }
  .van-radio {
    margin: 12px;
  }
  .van-checkbox {
    margin-left: 12px;
  }
  .van-checkbox__label {
    margin: 12px;
    text-align: left;
  }
  .margin-right-12 {
    margin-right: 12px;
  }
  .margin-bottom-12 {
    margin-bottom: 12px;
  }
  table,
  th,
  td {
    border: 1px solid black;
  }

  .other {
    padding: 0px;
    text-align: left;
  }
  .body {
    //margin-top: .5rem;
    .title {
      text-align: center;
      font-size: 24px;
    }
    .content {
      margin: 12px;
      text-indent: 34px;
    }
    .q {
      margin-left: 16px;
      margin-right: 12px;
      .q_title {
        float: left;
        text-align: left;
      }
    }
    .apply {
      text-align: center;
      &_title {
        font-size: 18px;
        width: 50%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question7.vue